// eslint-disable-next-line no-restricted-imports -- TODO(FEI-7300): Replace with new semanticColor
import {color} from "@khanacademy/wonder-blocks-tokens";

export const GuideColors = {
    darkPurple: color.eggplant,
    lightPurple: "#DCBBDA",
    peach: "#F7F3FF",
    pink: "#F5CFFF",
} as const;
